module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	fox.registerWidget('Form_Element_Select', {
		configure: function(options) {
			this.registerOptions('', {
				isSelected: false,
				updateNodeOnAddToDom: false,
			});

			this.callParent('configure', arguments);
		},

		init: function () {
			var wToListen;

			this.selectedIndx;

			if (this.getOption('updateNodeOnAddToDom') === true) {
				wToListen = this.getParent().wom1(this.getParent().getOption('container'));

				if (wToListen) {
					this.handleEvent(
						wToListen,
						'addedToDom',
						'updateDomNode',
						{alwaysActive: true}
					);
				}
			}
		
			this.callParent('init', arguments);
		},

		updateDomNode: function () {
			var newNode, parent;

			parent = this.getParent();

			if (typeof this.selectedIndx !== 'undefined') {
				newNode = fox.dom.selectFirst(parent.getOption(['formElements', this.getAlias(), 'element'].join('.')), parent.getContainer());
				
				newNode.parentNode && newNode.parentNode.replaceChild(this.formElement, newNode);
			}
		},

		getValue: function () {
			if (this.formElement.multiple) {
				var values = [];

				fox.each(this.formElement.options, function(option, key) {
					if (option.selected) {
						values.push(option.value || option.text);
					}
				}, values);

				return values;
			}

			if (this.formElement.options[this.formElement.selectedIndex]) {
				return  this.formElement.options[this.formElement.selectedIndex].value;
			}

			return  this.emptyValue;
		},

		getSelectedOption: function() {
			if (this.formElement.selectedIndex < 0) {
				return false;
			}

			var selectedOption = this.formElement.options[this.formElement.selectedIndex];

			if (!this.getOption('isSelected')) {
				return false;
			}
			
			return {
				text: selectedOption.innerHTML,
				value: selectedOption.value,
				index: this.formElement.selectedIndex
			};
		},

		_setValue: function (value) {
			this.selectedIndx = this.formElement.selectedIndex;

			fox.each(this.formElement.options, function (optionItem, i) {
				optionItem.selected = false;

				if (value == optionItem.value || (this.formElement.multiple && fox.inArray(value, optionItem.value))) {
					optionItem.selected = true;
					this.setOption('isSelected', true);
				}
			}, this);

			return this;
		}

	}, 'Form_Element');
})(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-core-resource/lib/widgets/form/elements/select.js
// module id = 196
// module chunks = 0